export const MegaMenu = () => {
    const firstElement = document.querySelectorAll('.mega-menu__first');

    firstElement.forEach(element => {
        const subtitle = element.dataset.subtitle;
        const parent = element.parentElement.nextElementSibling;

        if (parent !== null) {
            const li = document.createElement("li");
            li.classList.add('col-span-2');
            li.classList.add('mega-menu__subtitle');
            li.appendChild(document.createTextNode(subtitle));
            parent.prepend(li);
        }


    })

};